
import Helper from "./Helper";

class LottieSwiper {
  constructor() {
    this.lotties = document.querySelectorAll("lottie-player");
    this.lottiesArray = Array.prototype.slice.call(this.lotties);
    this.classIn = "is-in-viewport";
    this.classOut = "is-not-in-viewport";
    this.wasActiveMap = new WeakMap();

    if (this.lotties && this.lotties.length !== 0) {
      this.registerObserver();
      this.registerSlideObserver();
    }
  }

  registerObserver() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const container = entry.target;
        const lottie = container.matches("lottie-player")
          ? container
          : container.querySelector("lottie-player");

        if (!lottie) {
          return;
        }

        const slide = container.closest(".swiper-slide");
        const isActiveSlide =
          !slide ||
          slide.classList.contains("swiper-slide-active");

        if (entry.isIntersecting && isActiveSlide) {
          Helper.addClass(container, this.classIn);
          Helper.removeClass(container, this.classOut);
          this.playWhenReady(lottie);
        } else {
          Helper.removeClass(container, this.classIn);
          Helper.addClass(container, this.classOut);
          if (typeof lottie.stop === "function") {
            lottie.stop();
          }
        }
      });
    }, {
      root: null,
      rootMargin: "0px",
      threshold: 0
    });

    this.lottiesArray.forEach((item) => {
      const target = this.getObserverTarget(item);
      if (target) {
        observer.observe(target);
      }
    });
  }

  registerSlideObserver() {
    const wrappers = document.querySelectorAll(".highligts-slider .swiper-wrapper");

    wrappers.forEach((wrapper) => {
      this.syncSlidesInWrapper(wrapper);

      const classObserver = new MutationObserver(() => {
        this.syncSlidesInWrapper(wrapper);
      });

      classObserver.observe(wrapper, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ["class"]
      });
    });
  }

  syncSlidesInWrapper(wrapper) {
    const slides = wrapper.querySelectorAll(".swiper-slide");

    slides.forEach((slide) => {
      const isActiveSlide = slide.classList.contains("swiper-slide-active");
      const inViewport = this.isElementInViewport(slide);
      const lotties = slide.querySelectorAll("lottie-player");

      lotties.forEach((lottie) => {
        const wasActive = this.wasActiveMap.get(lottie) === true;

        if (isActiveSlide && inViewport) {
          // Enable looping
          lottie.loop = true;
          // Remove any previous 'complete' event to avoid stacking
          lottie.removeEventListener("complete", lottie._loopHandler);
          // Add a handler to restart animation when complete
          lottie._loopHandler = () => {
            if (isActiveSlide && inViewport) {
              lottie.stop && lottie.stop();
              lottie.play && lottie.play();
            }
          };
          lottie.addEventListener("complete", lottie._loopHandler);
          if (!wasActive) {
            lottie.stop && lottie.stop();
            this.playWhenReady(lottie);
          }
        } else {
          // Disable looping
          lottie.loop = false;
          lottie.removeEventListener("complete", lottie._loopHandler);
          if (wasActive && typeof lottie.stop === "function") {
            lottie.stop();
          }
        }
        this.wasActiveMap.set(lottie, isActiveSlide && inViewport);
      });
    });
  }

  isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < window.innerHeight;
  }

  playWhenReady(lottie) {
    if (typeof lottie.play !== "function") {
      return;
    }

    if (typeof lottie.getLottie === "function" && lottie.getLottie()) {
      lottie.play();
      return;
    }

    lottie.addEventListener("ready", () => lottie.play(), { once: true });
  }

  getObserverTarget(item) {
    const parent = item.closest(".highligts-slider__item");
    if (parent) {
      return parent.querySelector(".highligts-slider-item__content");
    }
    return item;
  }

}

export default LottieSwiper;

